import {useState} from 'react'

export default (initialState = null, defaults = {}) => {
  const withDefaults = (state, update) => {
    if (!update) return state

    const base = state || {}
    let result = {...base, ...update}

    for (let key in defaults) {
      result[key] = {
        ...defaults[key],
        ...(base[key] || {}),
        ...(update[key] || {})
      }
    }

    return result
  }

  const [state, setState] = useState(withDefaults(initialState))

  const mergeState = newState => setState(withDefaults(state, newState))

  const resetState = newState => setState(withDefaults(initialState, newState))

  return [state, mergeState, resetState]
}
